export const ArticleItem = ({ image, title, text, hrefUrl = '#' }) => (
  <a className="flex items-center gap-4" href={hrefUrl}>
    <img
      className="rounded-lg h-[6.25rem] w-[9rem] object-cover"
      src={image}
      alt="news-image"
      loading="eager"
    />
    <div className="flex flex-col gap-1">
      <div className="menu-news-article-title w-[15rem]">{title}</div>
      <div className="menu-news-article-text w-[13rem]">
        <div dangerouslySetInnerHTML={{ __html: text }} className="inline"></div>
      </div>
    </div>
  </a>
);
